module.exports = __webpack_public_path__ + "img/audit_en.ffda8368.png";